import React, { useState } from "react";
import { Buffer } from "buffer";
import {
  Card,
  Box,
  Button,
  Grid,
  Stack,
  Dialog,
  TextField,
  Typography,
  DialogActions,
  DialogContent,
  CircularProgress
} from "@mui/material";
import Header from "../components/Header";

import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import HomeIcon from "@mui/icons-material/Home";
const { encryptPayload, decryptPayload } = require("../utils/custom-hash");
const qz = require("qz-tray");

function OfflineTicket() {
  const location = useLocation();
  const navigate = useNavigate();
  const { serviceId,groups,services, branchDetails, serviceName } =
    location.state || {};
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const [ticketModalOpen, setTicketModalOpen] = useState(false);

  const [ticketNumber, setTicketNumber] = useState(null);
  const [tokenNumber, setTokenNumber] = useState(null);
  const [branchName, setBranchName] = useState(null);
  const [ticketServiceName, setTicketServiceName] = useState(null);

  const [customerName, setCustomerName] = useState(null);

  const [currentQueuePosition, setCurrentQueuePosition] = useState(null);

  const [issueTime, setIssueTime] = useState(null);

  const [issueDate, setIssueDate] = useState(null);


  const [errorMessage, setErrorMessage] = useState("");
  const branchId = branchDetails?.branchId;


  const handlePrintViaQZTray = async (ticketData, settings) => {
    // Helper function to pad string to fixed length
    const padString = (str, length) => {
      if (!str) return "".padEnd(length, " ");
      return str.length > length
        ? str.substring(0, length)
        : str.padEnd(length, " ");
    };

    const ticketContent = [
      "===============================",
      `      ${branchDetails?.branchName || "Branch Name"}`,
      "===============================",
      `Ticket No   : ${ticketData.token}`,
      `Service     : ${ticketData.serviceName}`,
      `Status      : ${ticketData.status}`,
      `Issued At   : ${new Date(ticketData.issueTime).toLocaleString()}`,
      // `Name        : ${ticketData.customerName}`,
      // `Email       : ${ticketData.customerEmail}`,
      // `Contact     : ${ticketData.customerContact}`,
      "-------------------------------",
      "Thank you for visiting!",
      "===============================",
      "" // extra line for spacing
    ].join("\n");  // <== Guarantees clean newlines

    const cutCommand = '\x1D\x56\x42\x00'; // Full cut command (for Epson-style printers)

    try {
      await qz.websocket.connect();
      const printerData = await qz.printers.getDefault();
      // console.log("FOUND PRINTER:", printerData); // Check the printer details

      let config = qz.configs.create(printerData); // Get printer config

      // First print ticket content
      await qz.print(config, [{
        type: 'raw',
        flavor: 'plain',
        data: ticketContent + cutCommand
      }]);

      setTicketModalOpen(true); // Display modal after printing

    } catch (err) {
      console.error("Error during printing:", err);
    } finally {
      await qz.websocket.disconnect();
    }
  };

  const onSubmit = async (data) => {
    try {
      setErrorMessage("");
      setLoading(true); // Start loading

      const payload = {
        branchId,
        serviceId,
        customerName: data.name,
        customerMail: data.email,
        customerContact: data.contactNumber,
        customerType: "walk-in",
        numOfCustomer:data.numOfCustomer,
        additionalInformation:data.additionalInformation
      };

      const encryptedPayload = await encryptPayload(payload);
      // console.log("Ticket Payload:", encryptedPayload);

      const response = await fetch(
        `${process.env.REACT_APP_ASERVER}/api/kiosk/ticket/generate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            encryptedPayload: encryptedPayload,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json(); // Parse the error message
        setLoading(false);
        setErrorMessage(errorData.message || "Failed to generate ticket"); // Update error message state
        return; // Exit the function if there is an error
      }
      const result = await response.json();
      setTicketNumber(result.ticket);
      setTokenNumber(result.ticketToken);
      setBranchName(result.branchName);
      setTicketServiceName(result.serviceName);
      setCustomerName(result.customerName);
      setCurrentQueuePosition(result.currentQueuePosition);
      setIssueTime(result.issueTime);
      setIssueDate(result.issueDate);
      setTicketModalOpen(true);
      reset();
      setLoading(false);
    } catch (error) {
      console.error("Error generating ticket:", error);
      // Optionally set a generic error message if something goes wrong that is not API-related
      setErrorMessage(
        error.message || "Error generating ticket. Please try again later."
      );
      setLoading(false);
    }
  };

  const handlePrint = async () => {
    try {
      // Prepare the payload for printing the ticket
      const printPayload = {
        ticketNumber,
        branchId: branchDetails?.branchId,
      };
      // console.log("ticketNumber ID:", ticketNumber);
      // console.log("Branch ID:", branchId);
      const encryptedPrintPayload = await encryptPayload(printPayload);
      // console.log("Encrypted Branch ID:", encryptedPrintPayload);

      const response = await fetch(
        `${process.env.REACT_APP_ASERVER}/api/kiosk/ticket/print`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ encryptedPayload: encryptedPrintPayload }),
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");
      const result = await response.json();

      if (result.success) {
        // const printPayload = {
        //   tokenNumber: result.ticket.ticketId,
        //   branch: result.ticket.branch,
        //   estimatedWaitingTime: result.ticket.estimatedWaitingTime,
        //   branchContact: result.ticket.branchContact,
        //   status: result.ticket.status,
        //   issueTime: result.ticket.issueTime,
        //   serviceName: result.ticket.serviceName,
        //   counterName: result.ticket.counterName,
        //   customerName: result.ticket.customerName,
        //   customerEmail: result.ticket.customerEmail,
        //   customerContact: result.ticket.customerContact,
        // };

        const ticketData = decryptPayload(result.ticket);
        // console.log('@@@ticketData--', ticketData);
        const printPayload = {
          payload: {
            tokenno: tokenNumber,
            status: ticketData.status,
            issueTime: ticketData.issueTime,
            serviceName: ticketData.serviceName,
            counterName: ticketData.counterName,
            customerName: ticketData.customerName,
            customerEmail: ticketData.customerEmail,
            customerContact: ticketData.customerContact
          },
          config: {
            branchId: result.settings.branchId,
            hasImageHeader: result.settings.hasImageHeader,
            imageHeader: result.settings.imageHeader,
            dateFormat: result.settings.dateFormat,
            contactNumber: result.settings.contactNumber,
            hasTextHeader: result.settings.hasTextHeader,
            hideTheTime: result.settings.hideTheTime,
            printDuplicate: result.settings.printDuplicate,
            printEstimatedWaitingTime: result.settings.printEstimatedWaitingTime,
            printQueuePosition: result.settings.printQueuePosition,
            paperSize: result.settings.paperSize,
            textHeader: result.settings.textHeader
          }
        };

        // === QZ Tray (Shreyans Printer) Printing ===
        await handlePrintViaQZTray(ticketData, result.settings);

      } else {
        console.error(result.message || "Error printing ticket.");
      }
    } catch (error) {
      console.error("Error submitting ticket:", error);
    } finally {
      // Always navigate to the kiosk screen
      setTicketModalOpen(false);
      reset();
      navigate("/");
    }
  };


  const handleCancel = () => {
    reset(); // Clear the form fields
    navigate("/services", {
      state: { groups,services, branchDetails }, // Pass services and branchId to /services route
    });
  };

  const handlehome = () => {
    navigate("/"); // Adjust the path to your main route
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#f0f2f5",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Header />
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          padding: 0,
        }}
      >
        <Card
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0)",
            height: "auto",
            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              paddingLeft: { xs: 3, sm: 10, md: 20 },
              paddingRight: { xs: 4, sm: 10, md: 10 },
              flexGrow: 1,
            }}
          >
            <Grid container sx={{ width: "90%", backgroundColor: "#f0f2f5" }}>
              <Grid item xs={12} mt={4}>
                <Card
                  sx={{
                    width: "100%",
                    padding: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1}
                    alignItems="center"
                  >
                    <Typography
                      variant="h5"
                      sx={{ flex: 1, textAlign: { xs: "center", sm: "left" } }}
                    >
                      {branchDetails?.branchName || "Branch Name"}
                    </Typography>
                    <Typography variant="h5" sx={{ display: { xs: "none", sm: "block" } }}>
                      |
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ flex: 1, textAlign: { xs: "center", sm: "right" } }}
                    >
                      {serviceName || "Generate Ticket"}
                    </Typography>
                  </Stack>
                </Card>

              </Grid>

              <Grid item xs={12} mt={4} mb={2}>
                <Card
                  sx={{
                    width: "100%",
                    padding: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                  }}
                >
                  <Stack spacing={3}>
                    <Typography
                      variant="h5"
                      align="center"
                      fontWeight="bold"
                      gutterBottom
                    >
                      {"Generate Ticket"}
                    </Typography>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            {...register("name", {
                              required: "Name is required",
                            })}
                            label="Name"
                            variant="outlined"
                            fullWidth
                            error={!!errors.name}
                            helperText={errors.name?.message}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            {...register("contactNumber", {
                              validate: (value) => {
                                if (!value) return true; // not required
                                if (!/^\d+$/.test(value)) return "Phone Number must contain only numbers";
                                if (!/^\d{10}$/.test(value)) return "Enter a valid 10-digit phone number";
                                return true;
                              },
                            })}
                            label="Phone Number"
                            variant="outlined"
                            fullWidth
                            error={!!errors.contactNumber}
                            helperText={errors.contactNumber?.message}
                          />

                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                           {...register("email", {
                              validate: (value) => {
                                if (!value) return true; // Optional field
                                const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
                                return isValidEmail || "Enter a valid email address";
                              },
                            })}
                          
                            label="Email"
                            variant="outlined"
                            fullWidth
                            error={!!errors.email}
                            helperText={errors.email?.message}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            {...register("numOfCustomer", {
                              validate: (value) => {
                                if (!value) return true; // Optional field
                                const numValue = parseInt(value);
                                if (isNaN(numValue)) return "Must be a number";
                                if (numValue < 0) return "Minimum 0 customer required";
                                if (numValue > 20) return "Maximum 20 customers allowed";
                                if (value.includes('.')) return "Must be a whole number";
                                return true;
                              }
                            })}
                            type="number"
                            inputProps={{ min: 0, max: 20 }}
                            label="No. of Customers"
                            variant="outlined"
                            fullWidth
                            error={!!errors.numOfCustomer}
                            helperText={errors.numOfCustomer?.message}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            {...register("additionalInformation", {
                              validate: (value) => {
                                if (!value) return true; // Optional field
                                return /^[a-zA-Z0-9,\s]*$/.test(value) || 
                                  "Only letters, numbers, spaces and commas are allowed";
                              }
                            })}
                            label="Additional Information"
                            variant="outlined"
                            multiline
                            rows={3}
                            fullWidth
                            error={!!errors.additionalInformation}
                            helperText={errors.additionalInformation?.message}
                          />
                        </Grid>

                      
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {errorMessage && (
                            <div style={{ color: "red", marginTop: "10px", justifyContent: "right" }}>
                              {errorMessage}
                            </div>
                          )}
                        </Grid>
                      </Grid>

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={2}>
                          <Stack spacing={2} mt={2}>
                            {" "}
                            <Button
                              variant="outlined"
                              sx={{
                                borderColor: "#1877f2",
                                color: "#1877f2",
                                borderRadius: 2,
                                height: 50,
                              }}
                              onClick={handlehome}
                            >
                              <HomeIcon
                                style={{ color: "#064EB4" }}
                                onClick={handlehome}
                              />{" "}
                              Home
                            </Button>
                            <Typography
                              variant="h6"
                              align="justify"
                              fontWeight="bold"
                            ></Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Stack spacing={2} mt={2}></Stack>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Stack spacing={2} mt={2}>
                            <Button
                              variant="outlined"
                              sx={{
                                borderColor: "#1877f2",
                                color: "#1877f2",
                                borderRadius: 2,
                                height: 50,
                              }}
                              onClick={handleCancel}
                            >
                              Cancel
                            </Button>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Stack spacing={2} mt={2}>
                            <Button
                              type="submit"
                              variant="contained"
                              disabled={loading} // Disable button when loading
                              sx={{
                                backgroundColor: "#1877f2",
                                color: "white",
                                borderRadius: 2,
                                height: 50,
                              }}
                            >
                              {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Generate Ticket"}
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                    </form>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Box>

      {/* Ticket Modal */}
      <Dialog
        fullWidth
        maxWidth="xs"
        open={ticketModalOpen}
        onClose={() => setTicketModalOpen(false)}
        // PaperProps={dialogPaperProps}
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 2,
            boxShadow: 3,
            opacity: 1, // opacity should be within sx
            width: 300,
          },
        }}
      >

        <DialogContent>
          <Typography variant="subtitle2" color="text.secondary" textAlign="center">
           JN Group
          </Typography>
          <Typography variant="h6" color="text.secondary" textAlign="center" sx={{ mb: 2 }}>
            {branchName}
          </Typography>

          <Box
            sx={{

              backgroundColor: "#f9f9f9",
              border: '1px solid #ddd',
              borderRadius: 1,
              padding: 2,
              mb: 3,
            }}
          >
            <Typography variant="h6" sx={{ textAlign: 'center', mb: 1 }}  >
              {ticketServiceName}
            </Typography>
            <Typography variant="h5" sx={{ textAlign: 'center', color: '#1877f2' }}>
              {tokenNumber}
            </Typography>
            <Typography variant="h6" color="success.main" sx={{ textAlign: 'center', mb: 2, color: '#1877f2' }}>
              {customerName}
            </Typography>
          </Box>

          <Typography variant="subtitle1" color="text.secondary" sx={{ textAlign: 'center', mb: 1 }}>
            You are Number {currentQueuePosition} in line
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            <span role="img" aria-label="calendar">
              📅
            </span>{' '}
            {issueDate}{' '}
            <span role="img" aria-label="clock">
              ⏰
            </span>{' '}
            {issueTime}
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            variant="contained"

            onClick={handlePrint}
            sx={{
              backgroundColor: "#1877f2",
              color: "white",

              width: '120px',
              height: '40px',
              fontSize: '16px',
              fontWeight: 'bold',
              borderRadius: '20px',
            }}
          >
            Print
          </Button>
        </DialogActions>


      </Dialog>
    </Box>
  );
}

export default OfflineTicket;
